import axios from 'axios'
import { toast } from 'react-toastify'
import qs from 'qs'

const api = axios.create({
    baseURL: 'http://www.hashminer.net/gw/wkapp',
    timeout: 10000,
    headers: {
        Authorization: 'Basic c2xmLXdrYXBwOnNsZi13a2FwcC05OTY5OTY='
    }

})

// 请求拦截器
api.interceptors.request.use(
    (config) => {
        if (config.method === 'GET') {
            config.headers['content-type'] = 'application/x-www-form-urlencodedcharset=utf-8'
        } else {
            config.headers['content-type'] = 'application/x-www-form-urlencoded'
            config.data = qs.stringify(config.data)
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// 响应拦截器
api.interceptors.response.use(
    (response) => {
        const { code, data, msg } = response.data
        if (code === 0) {
            return data
        } else {
            toast.warning(msg, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
            return Promise.reject(new Error(msg))
        }
    },
    (error) => {
        toast.error(error.message, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        })
        return Promise.reject(error)
    }
)

export default api
